import { render, staticRenderFns } from "./BaseButtonGroup.vue?vue&type=template&id=5f1575f7&scoped=true&"
import script from "./BaseButtonGroup.vue?vue&type=script&lang=js&"
export * from "./BaseButtonGroup.vue?vue&type=script&lang=js&"
import style0 from "./BaseButtonGroup.vue?vue&type=style&index=0&id=5f1575f7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1575f7",
  null
  
)

export default component.exports